import React from 'react';

//import css
import './SideBarRight.css';

const SideBarRight = () => {

    return (
        <div className='sidebar-right'></div>
    );
}

export default SideBarRight;